import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import AccountRequestRequestForm, {
    AccountRequestFormStyles,
} from "@ucs/Components/GuestRequestForm/AccountRequestForm";
import React from "react";
import { FC, useState } from "react";
import { css } from "styled-components";

const enum fields {
    submitButtonText = "submitButtonText",
    successTitle = "successTitle",
    successMessage = "successMessage",
    redirectOnSubmit= "redirectOnSubmit",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.submitButtonText]: string;
        [fields.successTitle]: string;
        [fields.successMessage]: string;
        [fields.redirectOnSubmit]: LinkFieldValue;
    };
    extendedStyles?: AccountCreationRequestFormStyles;
}

type Props = OwnProps;

export interface AccountCreationRequestFormStyles {
    container?: GridContainerProps;
    formArea?: GridItemProps;
    formStyles?: AccountRequestFormStyles;
}

export const accountCreationRequest: AccountCreationRequestFormStyles = {
    container: {
        css: css`
            margin: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    css`
                        margin: 0 auto;
                    `,
                    null,
                    null,
                    null
                ],"max",);
            }}
            >${GridOffset}{
                width: unset !important;
            }
        `,
    },
    formArea: {
        width: [12, 12, 12, 12, 12],
    },
};

const AccountCreationRequestForm: FC<Props> = ({ extendedStyles, fields, id }) => {
    const { submitButtonText, successMessage, successTitle } = fields;
    const [styles] = useState(() => mergeToNew(accountCreationRequest, extendedStyles));
    //const redirectOnSubmit = useGetLink(fields.redirectOnSubmit || "");
    const link = useGetLink(fields.redirectOnSubmit || "");
    const redirectOnSubmit: LinkFieldValue = {
        type: "Url",
        value: link?.url || "",
    };
    
    
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.formArea}>
                <AccountRequestRequestForm
                    successTitle={successTitle}
                    successMessage={successMessage}
                    submitButtonText={submitButtonText}
                    extendedStyles={styles.formStyles}
                    redirectOnSubmit={redirectOnSubmit}                    
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: AccountCreationRequestForm,
    definition: {
        group: "Common",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "CTA",
            },
            {
                name: fields.successTitle,
                displayName: "Submit Success Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Message Sent",
            },
            {
                name: fields.successMessage,
                displayName: "Submit Success Message",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue:
                    "Thank you! Your Account Request has been sent and a Sales Representative will contact you shortly.",
            },
            {
                name: fields.redirectOnSubmit,
                displayName: "Confirmation Page Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Url",
                },
                fieldType: "General",
            } 
        ],
    },
};

export default widgetModule;
